const HTML_ENTITIES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

const escapeHtml = (value: string): string =>
  value.replace(/[&<>"']/g, (char) => HTML_ENTITIES[char]);

// Returns HTML with the matched term wrapped in <strong>. The source text is
// HTML-escaped (only the literal <strong> markers we add are real markup), so
// medical-record content cannot inject script even though this output is
// rendered as raw HTML.
export const highlightText = (fullText: string, searchTerm: string): string => {
  const text = fullText ?? '';
  if (!searchTerm) {
    return escapeHtml(text);
  }

  const escapedTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escapedTerm})`, 'gi');

  // split() with a capturing group interleaves matches at odd indices; escape
  // every fragment and wrap only the matches.
  return text
    .split(regex)
    .map((fragment, index) =>
      index % 2 === 1
        ? `<strong>${escapeHtml(fragment)}</strong>`
        : escapeHtml(fragment),
    )
    .join('');
};

export const formatId = (id: string): string =>
  id
    .replace(/\s/g, '-')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
